import { injectable } from 'inversify';
import { Link, TocItem } from '@/app/shared/models';
import { tocHrefEqualsPage } from '@/app/aspect/toc-utils';

interface ItemResult {
  links: Link[];
  found: boolean;
}

@injectable()
export class BreadcrumbService {
  public createItems(page: string, tocItem: TocItem, result: ItemResult|null = null, i = 0): ItemResult {
    if (result === null) {
      result = { links: [], found: false };
    }

    if (tocHrefEqualsPage(page, tocItem.href)) {
      result.found = true;

      return result;
    }

    if (tocItem.children) {
      for (const child of tocItem.children) {
        result = this.createItems(page, child, result, 1);

        if (result.found) {
          result.links = [{
            href: child.href,
            title: child.title
          }, ...result.links];

          if (i == 0) {
            result.links = [{
              href: this.getFirstChildHref(tocItem.children),
              title: tocItem.title
            }, ...result.links];
          }

          return result;
        }
      }
    }

    return result;
  }

  private getFirstChildHref(tocItems: TocItem[]): string|null {
    for (const tocItem of tocItems) {
      if (tocItem.href) {
        return tocItem.href;
      }

      if (tocItem.children) {
        return this.getFirstChildHref(tocItem.children);
      }
    }

    return null;
  }
}

export const BreadcrumbServiceSymbol = Symbol.for('BreadcrumbService');
